/**
 * Личный выбор звука центра уведомлений в текущем браузере, общий для компаний.
 * Не хранит подписки и не влияет на звук чатов. Недоступность storage не мешает UI.
 */

// При отсутствии сохранённого выбора звук включён; пользователи изолированы по ID.
export function getNotificationSoundEnabled(userId) {
  try {
    return localStorage.getItem(`notificationSound:${userId}`) !== "false";
  } catch {
    return true;
  }
}

// Сохраняет только выбор авторизованного пользователя, без данных уведомлений.
export function setNotificationSoundEnabled(userId, enabled) {
  if (!userId) return;
  try {
    localStorage.setItem(`notificationSound:${userId}`, String(enabled));
  } catch {
    // В приватном режиме выбор остаётся в store до перезагрузки страницы.
  }
}
